import React, { useEffect, useState, useCallback } from "react";
import MenuItemCard from "../components/MenuItemCard";
import { formatDate, toLocalISODate } from "../utils/helpers";
import { motion, AnimatePresence } from "framer-motion";
import api from "../api/api";
import { useApp } from "../context/AppContext";

export default function Order() {
  const { isTakeaway, setIsTakeaway, setUser } = useApp();
  const formatISO = (d) => toLocalISODate(d);

  const [selectableDates, setSelectableDates] = useState([]);
  const [openDate, setOpenDate] = useState(null);
  const [menuData, setMenuData] = useState({});
  const [itemTypes, setItemTypes] = useState({});
  const [loading, setLoading] = useState(false);
  const [timings, setTimings] = useState({});
  const [selectedType, setSelectedType] = useState(null);
const [searchText, setSearchText] = useState("");
  useEffect(() => {
    const today = new Date();
    const arr = Array.from({ length: 2 }, (_, i) => {
      const d = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);
      return formatISO(d);
    });
    setSelectableDates(arr);
    setOpenDate(arr[0]);
  }, []);

  useEffect(() => {
    if (selectableDates.length === 0) return;

    const fetchCustomerData = async (user) => {
      try {
        if (user?.Vid && user?.UserType) {
          const customerData = await api.GetIndividualCustomerList(user.Vid, user.UserType);
          console.log("GetIndividualCustomerList response:", customerData);

          const customer =
            customerData?.data?.GetIndividualCustomerListjs?.Table?.[0] ||
            customerData?.GetIndividualCustomerListjs?.Table?.[0] ||
            null;
            
          const companyData =
            customerData?.data?.GetIndividualCustomerListjs?.Table1?.[0] ||
            customerData?.GetIndividualCustomerListjs?.Table1?.[0] ||
            null;

          if (customer) {
            const updatedUser = {
              Vid: customer.Vid ?? "",
              Vcode: customer.VCode ?? "",
              name: customer.Vname?.trim() || "",
              mail: customer.Mail?.trim() || "",
              address: customer.Address1?.trim() || "",
              landmark: customer.Address2?.trim() || "", 
              area: customer.City?.trim() || "",
              division: customer.Division?.trim() || "",
              pin: (customer.Pincode || "").trim(),
              UserType: user.UserType,
              IsCodAvail: customer.IsCodAvail ?? user.IsCodAvail ?? 0,
              PinAllowed: customer.PinAllowed,
              companyAddress: companyData?.ComAddress?.trim() || "No.5/25, Balaji Street,Arumbakkam,Opp. Police Quarters, Taluk Office Road,Sri Venkatesa Perumal Nagar, Chennai -600106.",
              companyName: companyData?.ComName?.trim() || "Hitham Associates Private Limited",
              companyEmail: companyData?.Email?.trim() || "annamatchennai@gmail.com",
              companyState: companyData?.State?.trim() || "TAMILNADU"
            };

            setUser(updatedUser);
            localStorage.setItem("user", JSON.stringify(updatedUser));
            sessionStorage.setItem("individualCustomerList", JSON.stringify(customerData));
          }
        }
      } catch (err) {
        console.error("Error fetching individual customer list:", err);
      }
    };

    const fetchMenus = async () => {
      setLoading(true);
      const temp = {};
      const globalMap = {}; // ✅ used by cart + AppContext
      const typesMap = {};
      let timingsData = {};

      try {
        // ✅ Get user info from local or session storage
        const user =
          JSON.parse(localStorage.getItem("user")) ||
          JSON.parse(sessionStorage.getItem("user"));
        const userType = user?.UserType || "New User";
        const division = user?.division || "";

        // Fetch and update customer data
        await fetchCustomerData(user);

        for (const date of selectableDates) {
          const res = await api.GetMenuplan(date);
          const items = res?.GetMenuplanjs?.Table || [];
          const dateTypes =
            res?.GetMenuplanjs?.Table1?.map(
              (t) => ({ type: t.Item_Type?.toLowerCase(), isOrderAllowed: t.IsOrderAllowed })
            ) || [];
          timingsData = res?.GetMenuplanjs?.Table2?.[0] || {};

          const grouped = {};
          dateTypes.forEach((t) => (grouped[t.type] = []));

          items.forEach((itm) => {
            const type = itm.Item_Type?.toLowerCase() || "other";

            // ✅ Apply rate logic
            let regularPrice = 0;
            let appliedRate = "";
            if (userType === "Existing User") {
              if (division === "Circle1") {
                regularPrice = itm.Circle1Rate;
                appliedRate = "Circle1Rate (Existing User)";
              } else if (division === "Circle2") {
                regularPrice = itm.Circle2Rate;
                appliedRate = "Circle2Rate (Existing User)";
              } else if (division === "Circle3") {
                regularPrice = itm.Circle3Rate;
                appliedRate = "Circle3Rate (Existing User)";
              } else {
                regularPrice = itm.Circle3Rate;
                appliedRate = "Circle3Rate (Default Fallback)";
              }
            } else {
              regularPrice = itm.Circle3Rate;
              appliedRate = "Circle3Rate (New User)";
            }

            const takeawayPrice =
              itm.TakeAway !== undefined && itm.TakeAway !== null
                ? Number(itm.TakeAway)
                : Number(regularPrice) || 0;
            const price = isTakeaway ? takeawayPrice : (Number(regularPrice) || 0);

            console.log(
              `Item: ${itm.Item_Desc1} | UserType: ${userType} | Division: ${division} | Applied: ${appliedRate} | Rate: ₹${price}`
            );

            if (grouped[type]) grouped[type].push(itm);

            // ✅ Build lookup map
            globalMap[itm.ItemId] = {
              id: itm.ItemId,
              name: itm.Item_Desc1,
              type,
              price: Number(price) || 0,
              regularPrice: Number(regularPrice) || 0,
              takeawayPrice,
              isTakeaway,
              raw: itm,
              Item_No: itm.Item_No,
            };
          });

          temp[date] = grouped;
          const sortedTypes = dateTypes.sort((a, b) => b.isOrderAllowed - a.isOrderAllowed);
          typesMap[date] = sortedTypes;
        }

        setTimings(timingsData);
        window.__menuItemMap = { ...(window.__menuItemMap || {}), ...globalMap };

        setMenuData(temp);
        setItemTypes(typesMap);
      } catch (err) {
        console.error("Error fetching menu:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, [selectableDates, isTakeaway]);

  /* ✅ Toggle accordion open state */
  const handleToggle = useCallback(
    (dateStr) => {
      setOpenDate((prev) => (prev === dateStr ? null : dateStr));
    },
    [setOpenDate]
  );

  /* 🧩 Render each date's menu */
  const renderMenuForDate = (dateStr) => {
    const menu = menuData[dateStr] || {};
    const types = itemTypes[dateStr] || [];
    // Other menu is hidden for now. Keep the data intact so it can be enabled later.
    const visibleTypes = types.filter((typeObj) => typeObj.type !== "other");
    const typesToShow = selectedType ? visibleTypes.filter(t => t.type === selectedType) : visibleTypes;
    const isOpen = openDate === dateStr;

    return (
      <motion.div
        className="overflow-hidden border shadow-xl bg-gradient-to-br from-white via-red-50/20 to-red-50/10 rounded-3xl border-gray-200/50 backdrop-blur-sm"
        
        whileHover={{ scale: 1.01 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        style={{
          backgroundImage: `
            radial-gradient(circle at 30% 20%, rgba(255,237,213,0.2) 0%, transparent 50%),
            radial-gradient(circle at 70% 80%, rgba(255,251,235,0.15) 0%, transparent 50%)
          `
        }}
      >
        {/* Accordion Header - Enhanced with gradients and effects */}
        <motion.button
          onClick={() => handleToggle(dateStr)}
          className={`w-full flex justify-between items-center px-6 sm:px-8 py-4 sm:py-5 cursor-pointer transition-all select-none relative overflow-hidden ${
            isOpen
              ? "bg-gradient-to-r from-red-100 via-red-50 to-red-100 border-b-2 border-red-300"
              : "hover:bg-gradient-to-r hover:from-gray-50 hover:to-red-50"
          }`}
          whileHover={{ scale: 1.002 }}
          whileTap={{ scale: 0.998 }}
        >
          {/* Animated background effect */}
          <div className="absolute inset-0 transition-opacity duration-500 opacity-0 bg-gradient-to-r from-red-400/5 via-red-300/5 to-red-400/5 hover:opacity-100"></div>

          <div className="relative z-10 flex items-center gap-4">
            <motion.div
              className={`w-4 h-4 rounded-full shadow-md ${isOpen ? "bg-gradient-to-r from-red-500 to-red-500" : "bg-gradient-to-r from-gray-300 to-gray-400"}`}
              animate={{
                scale: isOpen ? [1, 1.2, 1] : 1,
                boxShadow: isOpen ? "0 0 20px rgba(245, 158, 11, 0.4)" : "0 2px 8px rgba(0,0,0,0.1)"
              }}
              transition={{ duration: 0.6 }}
            ></motion.div>
            <div>
              <span className="block text-lg font-bold leading-tight text-gray-900 sm:text-xl">
                {formatDate(dateStr, {
                  weekday: "long",
                  month: "short",
                  day: "numeric",
                })}
              </span>
              <span className="text-sm font-medium text-gray-600">
                {Object.keys(menu).length} meal types available
              </span>
            </div>
          </div>

          <motion.div
            animate={{
              rotate: isOpen ? 180 : 0,
              scale: isOpen ? 1.1 : 1
            }}
            transition={{
              duration: 0.5,
              ease: [0.25, 0.46, 0.45, 0.94]
            }}
            className="relative z-10 w-6 h-6 text-red-600"
          >
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </motion.div>

        
          <div className="absolute inset-0 transition-transform ease-out -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent hover:translate-x-full duration-800"></div>
        </motion.button>

        {/* Accordion Content - Smoother animations */}
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              key="content"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{
                duration: 0.5,
                ease: [0.25, 0.46, 0.45, 0.94], // Custom easing for smoother feel
                opacity: { duration: 0.3 }
              }}
              className="px-4 pb-4 sm:px-6 sm:pb-6"
            >
              {/* Meal Type Filter Buttons */}
              <div className="sticky top-0 z-10 py-3 mb-4 rounded-lg bg-white/90 backdrop-blur-sm">
                <div className="flex flex-wrap justify-center gap-3 px-4">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setSelectedType(null)}
                    className={`px-5 py-2.5 rounded-full font-semibold transition-all duration-300 shadow-md ${!selectedType ? 'bg-orange-500 text-white shadow-orange-300' : 'bg-white text-gray-700 hover:bg-orange-50 border border-gray-200'}`}
                  >
                    🍽️ All
                  </motion.button>
                  {visibleTypes.map(typeObj => {
                    const type = typeObj.type;
                    const emoji = type === 'breakfast' ? '🌅' : type === 'lunch' ? '🍽️' : type === 'dinner' ? '🌙' : '🍪';
                    return (
                      <motion.button
                        key={type}
                        whileHover={typeObj.isOrderAllowed ? { scale: 1.05 } : {}}
                        whileTap={typeObj.isOrderAllowed ? { scale: 0.95 } : {}}
                        onClick={() => typeObj.isOrderAllowed && setSelectedType(type)}
                        disabled={!typeObj.isOrderAllowed}
                        className={`px-5 py-2.5 rounded-full font-semibold capitalize transition-all duration-300 shadow-md ${selectedType === type ? 'bg-orange-500 text-white shadow-orange-300' : 'bg-white text-gray-700 hover:bg-orange-50 border border-gray-200'} ${!typeObj.isOrderAllowed ? 'opacity-50 cursor-not-allowed' : ''}`}
                      >
                        {emoji} {type}
                      </motion.button>
                    );
                  })}
                </div>
              </div>
              <div className="space-y-4 sm:space-y-6">
                {typesToShow.map(
                  (typeObj, idx) =>
                    menu[typeObj.type]?.length > 0 && (
                      <motion.div
                        key={typeObj.type}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.1, duration: 0.3 }}
                      >
                        {/* Section Header - Compact */}
                        <div className="flex items-center mb-3 sm:mb-4">
                          <span className="mr-2 text-lg sm:text-xl">
                            {typeObj.type === "breakfast"
                              ? "🌅"
                              : typeObj.type === "lunch"
                              ? "🍽️"
                              : typeObj.type === "dinner"
                              ? "🌙"
                              : typeObj.type === "other"
                              ? "🍪"
                              : "🍽️"}
                          </span>
                          <h4 className="text-sm font-semibold text-gray-700 capitalize sm:text-base">
                            {typeObj.type} ({menu[typeObj.type].length} items)
                          </h4>
                        </div>
                        <p className="mb-3 text-xs font-bold text-gray-800 sm:text-sm">Order Before: {timings[typeObj.type.charAt(0).toUpperCase() + typeObj.type.slice(1)] || 'N/A'}</p>

                        {/* Menu Grid - Optimized for compact cards */}
                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-4 justify-items-center">
                          {menu[typeObj.type]
  .filter(item => {
    if (!searchText) return true;
    return item.Item_Desc1?.toLowerCase().includes(searchText.toLowerCase());
  })
  .map((item, itemIdx) => (
                            <motion.div
                              key={`${dateStr}-${typeObj.type}-${item.ItemId}-${itemIdx}`}
                              initial={{ opacity: 0, scale: 0.9 }}
                              animate={{ opacity: 1, scale: 1 }}
                              transition={{ delay: 0.1 + itemIdx * 0.03, duration: 0.3 }}
                              className="w-full max-w-sm"
                            >
                              <MenuItemCard item={item} dateStr={dateStr} isOrderAllowed={typeObj.isOrderAllowed} />
                            </motion.div>
                          ))}
                        </div>
                      </motion.div>
                    )
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    );
  };

  /* 🖼️ Render main layout */
  return (
    <div className="relative min-h-screen pb-20 animate-fade-in">
      {/* Animated background elements */}
      <div className="absolute w-32 h-32 rounded-full top-20 left-10 bg-red-300/10 blur-3xl animate-pulse"></div>
      <div className="absolute w-24 h-24 rounded-full top-40 right-20 bg-red-300/15 blur-2xl animate-pulse" style={{animationDelay: '2s'}}></div>
      <div className="absolute w-40 h-40 rounded-full bottom-32 left-1/4 bg-red-300/8 blur-3xl animate-pulse" style={{animationDelay: '4s'}}></div>
      

      {/* <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-4 text-2xl font-black text-center text-gray-900 sm:text-3xl md:text-4xl sm:mb-6"
      >
        Plan Your Subscription (Next 2 Days)
      </motion.h2> */}

      {/* Date Selection - Enhanced with gradients and effects */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="relative p-5 mb-6 overflow-hidden border shadow-lg bg-gradient-to-br from-white via-red-50/30 to-red-50/20 sm:p-6 sm:mb-8 rounded-2xl border-gray-200/50 backdrop-blur-sm"
        style={{
          backgroundImage: `
            radial-gradient(circle at 20% 30%, rgba(255,237,213,0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(255,251,235,0.2) 0%, transparent 50%)
          `
        }}
      >
        {/* Floating decorative elements */}
        <div className="absolute w-3 h-3 rounded-full top-4 right-6 bg-red-400/20 animate-pulse"></div>
        <div className="absolute w-2 h-2 rounded-full bottom-4 left-8 bg-red-400/30 animate-pulse" style={{animationDelay: '1s'}}></div>

        <div className="relative z-10 flex items-center justify-between mb-4">
          <motion.h3
            className="text-base font-bold text-gray-800 sm:text-lg"
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            🍽️ Choose a date to plan your meals
          </motion.h3>
          {/* <motion.span
            className="text-xs font-semibold text-red-700 bg-gradient-to-r from-red-100 to-red-100 px-3 py-1.5 rounded-full border border-red-200/50 shadow-sm"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.6, type: "spring" }}
          >
            Next 2 days only
          </motion.span> */}
        </div>
<div className="mb-4 text-center sm:text-left">
  <p className="text-sm font-medium tracking-wide text-gray-500 uppercase">
    Menu for
  </p>

  {openDate && (
    <h2 className="mt-1 text-xl font-bold text-gray-800 sm:text-3xl">
      {new Date(openDate).toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })}
    </h2>
  )}
</div>
        <div className="relative z-10 flex flex-wrap gap-3 sm:gap-4">
          {selectableDates.map((d, idx) => {
            const dt = new Date(d);
            const dayName = dt.toLocaleDateString("en-US", { weekday: "short" });
            const dayNum = dt.getDate();
            const isSelected = d === openDate;
            return (
              <motion.button
                key={d}
                initial={{ opacity: 0, scale: 0.8, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{
                  delay: 0.3 + idx * 0.1,
                  duration: 0.5,
                  type: "spring",
                  stiffness: 300
                }}
                whileHover={{
                  scale: 1.05,
                  y: -2,
                  boxShadow: isSelected
                    ? "0 15px 30px rgba(245, 158, 11, 0.4)"
                    : "0 10px 25px rgba(0,0,0,0.1)"
                }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleToggle(d)}
                className={`px-4 py-3 sm:px-5 sm:py-4 rounded-xl border-2 transition-all duration-300 text-sm sm:text-base font-semibold relative overflow-hidden ${
                  isSelected
                    ? "bg-gradient-to-br from-red-500 to-red-600 text-white border-red-400 shadow-xl"
                    : "bg-gradient-to-br from-white to-gray-50 text-gray-700 border-gray-300 hover:border-red-300 hover:from-red-50 hover:to-red-50"
                }`}
              >
                {/* Button background effect */}
                <div className={`absolute inset-0 bg-gradient-to-br ${
                  isSelected
                    ? "from-white/20 to-transparent"
                    : "from-red-400/10 to-red-400/5 opacity-0 hover:opacity-100"
                } transition-opacity duration-300`}></div>

                <div className="relative z-10 text-center">
                  <motion.div
                    className="mb-1 text-lg font-bold sm:text-xl"
                    animate={{
                      color: isSelected ? "#ffffff" : "#374151"
                    }}
                  >
                    {dayNum}
                  </motion.div>
                  <div className={`text-xs sm:text-sm font-medium ${
                    isSelected ? "text-red-100" : "text-gray-600"
                  }`}>
                    {dayName}
                  </div>
                </div>

                {/* Shine effect */}
                <div className="absolute inset-0 transition-transform ease-out -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent hover:translate-x-full duration-600"></div>
              </motion.button>
            );
          })}
        </div>
      </motion.div>
{/* 🔍 Search Bar */}
<div className="px-4 mb-6 sm:px-0">
  <div className="relative max-w-md mx-auto sm:mx-0">
    
    <input
      type="text"
      placeholder="Search meals (e.g. dosa, rice, upma...)"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      className="w-full px-4 py-3 pl-10 text-sm border border-gray-200 shadow-sm rounded-xl focus:outline-none focus:ring-2 focus:ring-red-300 focus:border-red-300"
    />

    {/* Icon */}
    <span className="absolute text-gray-400 left-3 top-3">
      🔍
    </span>

    {/* Clear button */}
    {searchText && (
      <button
        onClick={() => setSearchText("")}
        className="absolute text-gray-400 right-3 top-3 hover:text-red-500"
      >
        ✖
      </button>
    )}

  </div>
</div>
      {/* Menu Accordions */}
      {loading ? (
        <div className="py-12 text-center sm:py-16">
          <div className="inline-block w-10 h-10 mb-4 border-4 border-blue-300 rounded-full sm:w-12 sm:h-12 border-t-blue-600 animate-spin"></div>
          <p className="text-lg text-gray-600 sm:text-xl animate-pulse">
            Loading delicious menu...
          </p>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="space-y-6 sm:space-y-8"
        >
          {selectableDates.map((d, idx) => (
            <motion.div
              key={d}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 + idx * 0.1, duration: 0.6 }}
            >
              {renderMenuForDate(d)}
            </motion.div>
          ))}
        </motion.div>
      )}
    </div>
  );
}
